import { defineMessages } from 'react-intl';

export const creditUsagePopoverMessages = defineMessages({
  title: {
    defaultMessage: 'Usage',
    id: 'YKzn2phdim',
    description: 'Title for the credit usage upgrade popover',
  },
  consumedUsageDescription: {
    defaultMessage: "You've consumed {percent}% of your usage",
    id: 'tGvrJmEd8K',
    description:
      'Description in the credit usage popover before Clinician Max upgrade at sub-limit thresholds',
  },
  freeUsageDescription: {
    defaultMessage: 'You used {percent}% of free usage',
    id: 'fV+g/kBe7C',
    description:
      'Credit usage popover description for trial users on complimentary-style free usage',
  },
  almostOutOfUsageBanner: {
    defaultMessage: "You're almost out of usage",
    id: 'CZl9CF6p3K',
    description: 'Credit usage popover banner shown from 90% usage',
  },
  outOfUsageBanner: {
    defaultMessage: "You're out of usage. Upgrade for more.",
    id: 'z/aVTyiKeM',
    description: 'Credit usage popover banner shown at 100% usage',
  },
  complimentaryUntilBanner: {
    defaultMessage:
      'Enjoy $2000 of bonus usage on us until {date}. <learnMore>Learn more.</learnMore>',
    id: '/HO1J4FJOI',
    description:
      'Top status banner in the credit usage popover for Heidi 2 opt-in users on complimentary (uncapped) usage, dated from their billing cycle end, with a help-center learn-more link',
  },
  trialDaysRemainingDescription: {
    defaultMessage:
      '{days, plural, one {# day} other {# days}} left on your {plan, select, practiceMax {Practice} other {Clinician}} trial and complimentary usage. <learnMore>Learn more.</learnMore>',
    id: '/ZhGQSzI01',
    description:
      'Credit usage popover banner for trial users with at least 1 day remaining, plus a help-center learn-more link',
  },
  trialHoursRemainingDescription: {
    defaultMessage:
      '{hours, plural, one {# hour} other {# hours}} left on your {plan, select, practiceMax {Practice} other {Clinician}} trial and complimentary usage. <learnMore>Learn more.</learnMore>',
    id: 'Nmx0xtI7ZC',
    description:
      'Credit usage popover banner for trial users with under 24 hours remaining, plus a help-center learn-more link',
  },
  usagePercent: {
    defaultMessage: '{percent}%',
    id: '2T5YYzYC0c',
    description: 'Credit usage percentage label beside the progress bar',
  },
  usagePercentUsed: {
    defaultMessage: '{percent}% used',
    id: 'up74e0WsDW',
    description: 'Credit usage percentage caption under the popover progress bar',
  },
  unlimitedUsage: {
    defaultMessage: 'Unlimited',
    id: 'MrQg4okQeY',
    description:
      'Label beside the progress bar for Heidi 2 opt-in users whose usage is complimentary',
  },
  complimentaryUsageBanner: {
    defaultMessage: 'Complimentary usage until {date}',
    id: 'aC+BA8Tr0+',
    description:
      'Info banner in the credit usage popover for Heidi 2 opt-in users on complimentary usage',
  },
  resetsOn: {
    defaultMessage: 'Resets {date}, {time}',
    id: 'NL44snB6Sl',
    description: 'Caption under credit usage progress showing when credits reset',
  },
  upgradeCta: {
    defaultMessage: 'Upgrade to {planName}',
    id: 'NCHx13IGwE',
    description: 'CTA label for credit usage popover Max upgrade button',
  },
  upgrade: {
    defaultMessage: 'Upgrade',
    id: '3U6w8agsVR',
    description: 'CTA label for the Standard seat in the credit usage popover',
  },
  extendTrialCta: {
    defaultMessage: 'Extend your free trial',
    id: '4tfBpG0H21',
    description:
      'CTA in the credit usage popover that opens the gamified trial-extension checklist',
  },
  explorePlansCta: {
    defaultMessage: 'Explore plans',
    id: 'NtqJDkmCSs',
    description:
      'CTA label for the credit usage popover when a non-trial complimentary usage banner is shown',
  },
  clinicianMaxPlanName: {
    defaultMessage: 'Clinician Max',
    id: 'Cn07oTAjik',
    description: 'Display name for the Clinician Max plan in credit usage popover CTAs',
  },
  practiceMaxPlanName: {
    defaultMessage: 'Practice Max',
    id: 'TsAzRWYZ5I',
    description: 'Display name for the Practice Max plan in credit usage popover CTAs',
  },
  coverageTooltipTitle: {
    defaultMessage: 'About Usage',
    id: 'qRPplOWIj/',
    description: 'Title for the credit usage info tooltip in the usage popover',
  },
  coverageTooltipMonthlyRefresh: {
    defaultMessage:
      'Monthly usage comes with your subscription and refreshes on the same date each month.',
    id: 'OWo6b4cEDf',
    description: 'First bullet in the credit usage info tooltip',
  },
  coverageTooltipConsumption: {
    defaultMessage:
      'Usage is consumed by agentic tasks, scheduled routines, evidence queries and dictation. Note generation, transcription, templates and forms are always free.',
    id: 'SxaYsBUfgU',
    description: 'Second bullet in the credit usage info tooltip',
  },
  coverageTooltipVariableCost: {
    defaultMessage:
      'Different actions consume different amounts, a single agent run costs more than a write-back.',
    id: 'lGUtT8r2RQ',
    description: 'Third bullet in the credit usage info tooltip',
  },
  coverageTooltipAriaLabel: {
    defaultMessage: 'About usage',
    id: 'wJjio5DGn6',
    description: 'Accessible label for the credit usage info tooltip trigger',
  },
  triggerAriaLabel: {
    defaultMessage: 'Credit usage, {percent}% used',
    id: '5vkXmzQ4ik',
    description: 'Accessible label for the circular credit usage popover trigger',
  },
});
